import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BASE_URL, USER_URL } from '../../constant/api';
import axios from 'axios';
import DeleteModal from '../../components/DeleteModal/DeleteModal';
import ScaleLoader from "react-spinners/ScaleLoader";  // Import ScaleLoader

function SellerBrand() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);  // Loading state
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Fetch products on component mount
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);  // Set loading before fetching
        const response = await USER_URL.get(`/products/seller/brand/`);
        if (response.data?.data) {
          setProducts(response.data?.data);
        }
      } catch (error) {
        console.error("Error fetching products:", error.message || error);
      } finally {
        setLoading(false);  // Stop loading after fetching
      }
    };
    fetchProducts();
  }, []);

  // Handle delete confirmation
  const handleDelete = async () => {
    if (selectedProduct) {
      try {
        await USER_URL.delete(`/products/seller/brand/${selectedProduct.id}/`);
        setProducts(products.filter((p) => p.id !== selectedProduct.id));
        setShowConfirm(false);
        setSelectedProduct(null);
      } catch (error) {
        console.error("Error deleting product:", error.message || error);
      }
    }
  };

  return (
    <div className="p-6">
      
      {/* Header with Add New Banner Button */}
      <div className="flex justify-end items-center m-5">
        <Link
          to="/seller/offer/brand/addbrand"
          className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-6 rounded-lg shadow"
        >
          + Add New Brand
        </Link>
      </div>

      {/* Loading spinner */}
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <ScaleLoader color="#FFAE00" height={40} />
        </div>
      ) : (
        <div className="overflow-x-auto mt-4">
          <table className="w-full text-center">
            <thead>
              <tr>
                <th className="py-2 text-green-500 text-md font-bold">Item No</th>
                <th className="px-2 py-2 text-green-500 text-md font-bold">Brand Name</th>
                <th className="px-2 py-2 text-green-500 text-md font-bold">Status</th>
              
              </tr>
            </thead>
            <tbody>
              {products.length > 0 ? (
                products.map((product, index) => (
                  <tr key={product.id}>
                    <td className="py-3 px-2">
                      <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                        {index + 1}
                      </div>
                    </td>
                    
                    <td className="py-3 px-2">
                      <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                        {product.brandname || "Name"}
                      </div>
                    </td>

                    <td className="py-3 px-2">
                      <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                        {product.status || "Pending"}
                      </div>
                    </td>

                    <td className='py-3 px-4 text-sm'>
                      <div className="flex gap-5">
                        <Link
                          to={`/seller/offer/brand/edit/${product.id}`}
                          className="flex-1 flex items-center justify-center px-2 py-2 text-xs sm:text-sm font-medium text-blue-600 hover:text-white border border-blue-600 rounded-lg shadow-md hover:bg-blue-700 hover:border-blue-700 transition text-center"
                        >
                          Edit
                        </Link>

                        <button
                          className="flex-1 flex items-center justify-center px-2 py-2 text-xs sm:text-sm font-medium text-red-600 hover:text-white border border-red-600 rounded-lg shadow-md hover:bg-red-700 hover:border-red-700 transition text-center"
                          onClick={() => {
                            setSelectedProduct(product);
                            setShowConfirm(true);
                          }}
                        >
                          Delete
                        </button>

                        <Link
                          to={`/seller/offer/brand/view/${product.id}`}
                          className="flex-1 flex items-center justify-center px-2 py-2 text-xs sm:text-sm font-medium text-green-600 hover:text-white border border-green-600 rounded-lg shadow-md hover:bg-green-700 hover:border-green-700 transition text-center"
                        >
                          View
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center py-4 text-gray-600">
                    No brands found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showConfirm && (
        <DeleteModal
          entityName="brand"
          title={selectedProduct?.brandname}
          onConfirm={handleDelete}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
}

export default SellerBrand;

